import React from 'react';
import { ButtonTheme } from '@philips-internal/oswald-ui-constants';
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import { oneOf, string } from '@philips-internal/oswald-ui-core/lib/component/prop-types/index.js';
import { AuthenticationService, MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { enumValues, trigger } from '@philips-internal/oswald-ui-utils';
import { ReactComponent as XCircle } from '../../../resources/assets/components/circled-x.svg';
import { Button } from '../button/button.js';
import { InactivityAPI } from './inactivity-api.js';
import './inactivity.css';
function Inactivity(props) {
    return (React.createElement("div", { className: "c-inactivity" },
        React.createElement(XCircle, { className: "c-inactivity__icon" }),
        React.createElement("div", { className: "c-inactivity__text c-inactivity__title" }, MessageService.translate(props.titleExpression)),
        React.createElement("div", { className: "c-inactivity__text c-inactivity__message" }, MessageService.translate(props.messageExpression)),
        React.createElement(Button, { className: "c-inactivity__button", onClick: trigger(AuthenticationService.redirectToLogin), theme: props.backToLoginButtonTheme, value: props.backToLoginExpression })));
}
Inactivity.propTypes = {
    backToLoginButtonTheme: oneOf(enumValues(ButtonTheme)),
    backToLoginExpression: string,
    messageExpression: string,
    titleExpression: string,
};
Inactivity.defaultProps = {
    backToLoginButtonTheme: ButtonTheme.OUTLINE,
    backToLoginExpression: 'tws.inactivity.back-to-login',
    messageExpression: 'tws.inactivity.message',
    titleExpression: 'tws.inactivity.title',
};
const awesomeProps = {
    api: InactivityAPI,
    type: ComponentType.LAYOUT,
};
AwesomeComponent(awesomeProps)(Inactivity);
export { Inactivity, };
//# sourceMappingURL=inactivity.js.map